import { render, staticRenderFns } from "./0-enter-postcode.vue?vue&type=template&id=3f88767a"
import script from "./0-enter-postcode.vue?vue&type=script&lang=js"
export * from "./0-enter-postcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports